import { IObservable, Subject } from '~/rage/utils';
import {
	HudHintType,
	IHudHint,
	IHudOffer,
	IHudPlaytimeReward,
	IHudTaskProgress,
} from '~/shared';
import { IHudService } from './hudServiceTypes';

export class HudServiceStub implements IHudService {
	private offer = new Subject<IHudOffer | null>({
		title: 'Выгодное предложение',
		description: 'Новый кейс Lamborghini по скидке 25%',
		caseId: 'lambo_case',
		timer: 20000,
		color: '#FFA600',
	});
	private isOfferShown = false;

	private hint = new Subject<IHudHint | null>({
		type: HudHintType.Hospital,
	});

	private hudTask = new Subject<IHudTaskProgress | null>(null);

	private playtimeReward = new Subject<IHudPlaytimeReward | null>({
		amount: 500,
		expiresAt: Date.now() + 20 * 60 * 1000,
		isReceived: false,
	});

	constructor() {
		(global as any).setPlaytimeReward = (reward: IHudPlaytimeReward | null) => {
			this.playtimeReward.next(reward);
		};
	}

	public getOffer(): IObservable<IHudOffer | null> {
		return this.offer;
	}

	public setOfferShown(): void {
		if (!this.isOfferShown) {
			this.isOfferShown = true;
			setTimeout(() => {
				this.offer.next(null);
			}, 300);
		}
	}

	public getHint(): IObservable<IHudHint | null> {
		return this.hint;
	}

	public hideHint(): void {
		this.hint.next(null);
	}

	public getHudTask(): IObservable<IHudTaskProgress | null> {
		return this.hudTask;
	}

	public getPlaytimeReward(): IObservable<IHudPlaytimeReward | null> {
		return this.playtimeReward;
	}
}
